import { get_token,set_user_details, getCookie, set_drive_id } from '@/router/index.js';
import $ from 'jquery';
import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import Navbar from '@/components/Home_Navbar/NavbarView.vue';
import PoweredBy from '@/components/PoweredBy/PoweredByView.vue';


export default {
  name: 'ProfileView',
  components: {
    Sidebar,
    Navbar,
    PoweredBy
},
  data: () => ({
    user: {},
    form: {
    },
    original_user: null,
    original_company: null,
    original_profile: null,
    saving: false,
    user_profile: {
    phone_number: '',
    address: '',
    id_number: '',
    province: '',
    country: '',
    gender: ''
  },

  new_company: {
    company_name: '',
    registration_number: '',
    vat_number: '',
    phone_number: '',
    address: ''
  },
  user_initials: '',
  edit_mode: false,
  email_touched: false,
  email_error: '',
  registration_error: '',
  vat_error: '',
  id_number_error: null,


  }),
  computed: {
    is_email_valid() {
      const email = (this.user?.email || '').trim();
      if (!email) return false;
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      return re.test(email);
    },
  },

  mounted() {
    this.csrfToken = getCookie("csrftoken");
    this.get_user_details().then(() => {
      if (this.user.company_id) {
        this.get_company_profile(this.user.company_id);
      }
      else if (this.user.profile_id) {
        this.get_user_profile(this.user.profile_id);
      }
    });
    this.get_drive_id();
},

  methods: {
    get_own_data_descriptor(obj, key) {
      const d = Object.getOwnPropertyDescriptor(obj ?? {}, key);
      return d && d.enumerable && !('get' in d) && !('set' in d) ? d : null;
    },

    coerce_to_safe_string(v) {
      const COERCERS = { string: (x) => x, number: String, boolean: String };
      const fn = COERCERS[typeof v];
      return fn ? fn(v) : '';
    },

    safe_own_string(obj, key) {
      const d = this.get_own_data_descriptor(obj, key);
      return d ? this.coerce_to_safe_string(d.value) : '';
    },

    normalized_diff(a, b) {
      return this.normalize(a) !== this.normalize(b);
    },

    only_digits(event) {
      const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
      if (allowedKeys.includes(event.key)) return;
      if (!/[0-9/]/.test(event.key)) {
        event.preventDefault();
      }
    },

    validate_registration() {
      if (this.new_company.registration_number.length > 14) {
        this.new_company.registration_number = this.new_company.registration_number.slice(0, 14);
      }
      const reg_pattern = /^\d{4}\/\d{6}\/\d{2}$/;
      if (!reg_pattern.test(this.new_company.registration_number)) {
        this.registration_error = 'Please enter a valid registration number';
      } else {
        this.registration_error = '';
      }
    },

    on_registration_input(e) {
      const raw = e?.target?.value ?? '';
      const formatted = this.format_registration_number(raw);
      this.new_company.registration_number = formatted;
      this.validate_registration();
    },

    format_registration_number(value) {
      const digits = String(value).replace(/\D/g, '').slice(0, 12);

      const year = digits.slice(0, 4);
      const number_1 = digits.slice(4, 10);
      const number_2 = digits.slice(10, 12);

      let out = year;
      if (number_1) out += `/${number_1}`;
      if (number_2) out += `/${number_2}`;
      return out || '';
    },

    validate_vat() {
      if (this.new_company.vat_number.length > 10) {
        this.new_company.vat_number = this.new_company.vat_number.slice(0, 10);
      }
      const vat_pattern = /^\d{10}$/;
      if (!vat_pattern.test(this.new_company.vat_number)) {
        this.vat_error = 'Please enter a valid VAT number (10 digits)';
      } else {
        this.vat_error = '';
      }
    },

    on_email_input(e) {
      const value = (e?.target?.value ?? '').trim();
      this.user.email = value.toLowerCase();
      this.email_touched = true;
      this.email_error = this.is_email_valid ? '' : 'Please enter a valid email address.';
    },

    validate_before_save() {
      if (!this.is_email_valid) {
        this.email_touched = true;
        this.email_error = 'Please enter a valid email address.';
        this.$notyf.info('Invalid email. Please fix and try again.');
        return false;
      }
      return true;
    },


  validate_sa_id_number(id_number) {
    const id_regex = /^\d{13}$/;
    if (!id_regex.test(id_number)) return false;

    // Extract DOB parts
    const yy = id_number.substring(0, 2);
    const mm = id_number.substring(2, 4);
    const dd = id_number.substring(4, 6);

    // Determine century
    const today = new Date();
    const year = today.getFullYear().toString().substr(-2);
    const century = (parseInt(yy, 10) <= parseInt(year, 10)) ? '20' : '19';
    const full_year = parseInt(century + yy, 10);

    // Validate DOB
    const dob = new Date(full_year, parseInt(mm, 10) - 1, parseInt(dd, 10));
    if (
      dob.getFullYear() !== full_year ||
      dob.getMonth() !== parseInt(mm, 10) - 1 ||
      dob.getDate() !== parseInt(dd, 10)
    ) {
      return false;
    }

    // Luhn check
    return this.luhn_algorithm(id_number);
  },

  luhn_algorithm(id_number) {
    let sum = 0;
    let is_even = false;
    for (let i = id_number.length - 1; i >= 0; i--) {
      let digit = parseInt(id_number.charAt(i), 10);
      if (is_even) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      is_even = !is_even;
    }
    return (sum % 10 === 0);
  },

  validate_id_number() {
    this.user_profile.id_number = this.user_profile.id_number.replace(/\D/g, '').slice(0, 13);
    if (!this.user_profile.id_number || this.user_profile.id_number.trim() === '') {
      this.id_number_error = 'ID number is required';
    } else if (!this.validate_sa_id_number(this.user_profile.id_number)) {
      this.id_number_error = 'Invalid ID number';
    } else {
      this.id_number_error = null;
    }
  },
  get_drive_id() {
    const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/aic_drive/get_drive/';
    const token = get_token();
    if (!token) {
      this.$router.push({ name: 'Login' });
      return;
    }

    const user_id = localStorage.getItem('user_id');

    const payload = { user_id: user_id };

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        method: "GET",
        data: payload,
        headers: {
          "Authorization": `Token ${token}`
        },
        success: (response) => {
          const response_data = typeof response === "string" ? JSON.parse(response) : response;

          const drive_id = response_data.data.drive_id;
          set_drive_id(drive_id);  // store drive_id in localStorage

        },
        error: (xhr, status, error) => {
          console.error("Error fetching drive", xhr.responseText || error);
          reject(error);       // reject on error
        }
      });
    });
  },
  normalize(v) { return (v ?? '').toString().trim(); },

  core_user_changed() {
    if (!this.original_user) return false;
    return (
      this.normalize(this.user.first_name) !== this.normalize(this.original_user.first_name) ||
      this.normalize(this.user.last_name)  !== this.normalize(this.original_user.last_name)  ||
      this.normalize((this.user.email || '').toLowerCase()) !== this.normalize(this.original_user.email)
    );
  },

  company_changed() {
    if (!this.original_company) return true;
    const now = this.new_company || {};
    const orig = this.original_company;
    const fields = ['company_name', 'registration_number', 'vat_number', 'phone_number', 'address'];

    return fields.some(k =>
      this.normalized_diff(
        this.safe_own_string(now, k),
        this.safe_own_string(orig, k)
      )
    );
  },

  profile_changed() {
    if (!this.original_profile) return true;
    const now = this.user_profile || {};
    const orig = this.original_profile;
    const fields = ['phone_number','address','id_number','province','country','gender'];

    return fields.some(k =>
      this.normalized_diff(
        this.safe_own_string(now, k),
        this.safe_own_string(orig, k)
      )
    );
  },

  parse_backend_error(err) {
    if (!err) return "An unknown error occurred";

    if (err.data && typeof err.data === "object") {
      const keys = Reflect.ownKeys(err.data);
      return keys
        .map((key) => {
          const value = Reflect.get(err.data, key);
          if (Array.isArray(value)) return `${String(key)}: ${value.join(", ")}`;
          if (typeof value === "string") return `${String(key)}: ${value}`;
          return `${String(key)}: ${JSON.stringify(value)}`;
        })
        .join(" | ");
    }

    if (typeof err.message === "string") return err.message;
    if (typeof err.error === "string") return err.error;
    if (typeof err.detail === "string") return err.detail;

    if (typeof err === "object") {
      return JSON.stringify(err);
    }

    return String(err);
  },



  async update_core_user() {
    const token = get_token();
    if (!token) { this.$router.push({ name: 'Login' }); return false; }

    const payload = {
      first_name: (this.user.first_name || '').trim(),
      last_name: (this.user.last_name  || '').trim(),
      email: (this.user.email || '').trim().toLowerCase(),
    };

    const res = await fetch(
      `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/update_user/`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
          'X-CSRFToken': this.csrfToken,
          'X-Page-URL': window.location.href,
        },
        body: JSON.stringify(payload),
      }
    );
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status !== 'success') {
    const backend_error = this.parse_backend_error(data);
    this.$notyf.error(backend_error);
    return false;
  }

  if (data.data) { this.user = { ...this.user, ...data.data }; }
  set_user_details(this.user);
  return true;
  },

  async get_user_details() {
    const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_current_user/`;
    const token = get_token();
    if (!token) {
        this.$router.push({ name: 'Login' });
        return;
    }

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
        },
      });
      if (response.ok) {
        const response_data = await response.json();
        this.user = response_data.data;
        this.original_user = {
          first_name: this.user.first_name || '',
          last_name: this.user.last_name || '',
          email: (this.user.email || '').toLowerCase(),
        }
        set_user_details(this.user);

        if (this.user && this.user.first_name && this.user.last_name) {
          this.user_initials = this.user.first_name[0].toUpperCase() + this.user.last_name[0].toUpperCase();
        }
      } else {
           if (response.status === 403 || response.status === 401) {
                // Redirect to login on auth errors
                this.$router.push({ name: 'Login' });
            } else {
                this.$notyf.info('Error fetching user details');
            }
        }
      } catch (error) {
        this.$notyf.info('Error fetching user details');
      }
  },

  async create_user_profile() {
    const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/create_user_profile/`;
    const token = get_token();
    if (!token) {
      this.$router.push({ name: 'Login' });
      return;
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
          'X-CSRFToken': this.csrfToken
        },
        body: JSON.stringify(this.user_profile),
      });

      const data = await response.json();
      if (response.ok) {
        this.user_profile = data.data;
        this.$notyf.success('User profile created successfully');
        return true;
      }
      const backend_error = this.parse_backend_error(data);
      this.$notyf.error(backend_error);
      return false;
    } catch (error) {
      const backend_error = this.parse_backend_error(error);
      this.$notyf.error(backend_error);
      return false;
    }
  },

    async create_company_profile() {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/create_client_company/`;
      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      try {
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrfToken
          },
          body: JSON.stringify(this.new_company),
        });

        const data = await response.json();
        if (response.ok) {
          this.new_company = data.data;
          return true;
        }
        const backend_error = this.parse_backend_error(data);
        this.$notyf.error(backend_error);
        return false;
      } catch (error) {
        const backend_error = this.parse_backend_error(error);
        this.$notyf.error(backend_error);
        return false;
      }
    },

    async save_changes() {
      if (this.registration_error || this.vat_error || this.id_number_error) {
        return;
      }

      if (this.saving) return;
      this.saving = true;

      const is_org = (this.user?.client_type || '').toLowerCase() === 'organization';
      const core_changed = this.core_user_changed();
      const org_changed  = is_org ? this.company_changed() : false;
      const prof_changed = !is_org ? this.profile_changed() : false;

      if (!core_changed && !org_changed && !prof_changed) {
        this.$notyf.info('No changes to save.');
        this.edit_mode = false;
        this.saving = false;
        return;
      }

      if (core_changed) {
        if (!this.validate_before_save()) { this.saving = false; return; }
        const core = await this.update_core_user();
        if (!core) { this.saving = false; return; }
        this.original_user = {
          first_name: (this.user.first_name || '').trim(),
          last_name: (this.user.last_name || '').trim(),
          email: (this.user.email || '').trim().toLowerCase(),
        };
      }

      if (org_changed) {
        const r = await this.create_company_profile();
        if (!r) { this.saving = false; return; }
        this.original_company = {
          company_name: this.new_company.company_name || '',
          registration_number: this.new_company.registration_number || '',
          vat_number: this.new_company.vat_number || '',
          phone_number: this.new_company.phone_number || '',
          address: this.new_company.address || '',
        };
      }

      if (prof_changed) {
        const r = await this.create_user_profile();
        if (!r) { this.saving = false; return; }
        this.original_profile = {
          phone_number: this.user_profile.phone_number || '',
          address: this.user_profile.address || '',
          id_number: this.user_profile.id_number || '',
          province: this.user_profile.province || '',
          country: this.user_profile.country || '',
          gender: this.user_profile.gender || '',
        };
      }

      this.edit_mode = false;
      this.$notyf.success('Changes saved successfully');
      this.saving = false;
    },

    async get_company_profile(company_id) {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_client_company?company_id=${company_id}`;
      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      try {
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrfToken
          },
        });

        if (response.ok) {
          const response_data = await response.json();
          this.new_company = response_data.data;
          this.original_company = {
            company_name: this.new_company.company_name || '',
            registration_number: this.new_company.registration_number || '',
            vat_number: this.new_company.vat_number || '',
            phone_number: this.new_company.phone_number || '',
            address: this.new_company.address || '',
          };
        } else {
          this.$notyf.info('Error fetching organization details');
        }
      } catch (error) {
        this.$notyf.info('Error fetching organization details');
      }
    },

    async get_user_profile(profile_id) {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_user_profile?profile_id=${profile_id}`;
      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      try {
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrfToken
          },
        });

        if (response.ok) {
          const data = await response.json();
          this.user_profile = data.data;
          this.original_profile = {
            phone_number: this.user_profile.phone_number || '',
            address: this.user_profile.address || '',
            id_number: this.user_profile.id_number || '',
            province: this.user_profile.province || '',
            country: this.user_profile.country || '',
            gender: this.user_profile.gender || '',
          };
        } else {
          this.$notyf.info('Error fetching user profile');
        }
      } catch (error) {
        this.$notyf.info('Error fetching user profile');
      }
    },
  },
};
